const LINK = "https://webapi.vip-chef.ir/";
// const LINK = "http://localhost:3001/";

export default LINK;
